import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import CircularProgress from "@mui/material/CircularProgress";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./SwimLanes.css";

const SwimLanes = () => {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://tarunika.backendapihub.com/product/product-slider');
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const data = await response.json();
        
        if (data?.data?.length > 0) {
          const slidersList = data.data.map(item => item.slider);
          setSliders(slidersList);
        } else {
          setSliders([]);
        }
        setError(null);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to load products');
        setSliders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleProductClick = (l1_id) => {
    navigate(`/product/${l1_id}`);
  };

  // Show loading spinner while fetching data
  if (loading) {
    return (
      <div className="loading-container d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
        <CircularProgress sx={{ color: '#790101' }} />
      </div>
    );
  }

  // Show error message if fetch failed
  if (error) {
    return (
      <div className="error-container d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
        <div className="text-center">
          <p className="text-muted">{error}</p>
          <button 
            className="btn btn-outline-danger mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Return null if no sliders data available (no empty space)
  if (!sliders || sliders.length === 0) {
    return null; // This will prevent empty space from appearing
  }

  return (
    <div className="festival-kurtas-container container-fluid">
      {sliders.map((slider) => (
        <div key={slider.id} className="mb-5">
          <h3 className="section-heading">{slider.name}</h3>
          <div className="swimlane-scroll">
            {slider.products.map((product, index) => (
              <ImageCard
                key={index}
                product={product}
                onClick={() => handleProductClick(product.l1_id)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

// Reusable component with image loading fallback
const ImageCard = ({ product, onClick }) => {
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <div className="kurta-card" onClick={onClick}>
      {!imgLoaded && (
        <div className="img-placeholder d-flex align-items-center justify-content-center">
          <CircularProgress size={24} sx={{ color: '#790101' }} />
        </div>
      )}
      <img
        src={`https://tarunika.backendapihub.com/images/${product.mediaName[0]}`}
        alt={product.product_name}
        className="img-fluid"
        style={{ display: imgLoaded ? "block" : "none" }}
        onLoad={() => setImgLoaded(true)}
        onError={() => setImgLoaded(true)} // fallback in case image fails
      />
      <div className="kurta-details">
        <p className="kurta-name">{product.product_name}</p>
        <p className="kurta-price">₹ {product.price}</p>
      </div>
    </div>
  );
};

export default SwimLanes;